export default __webpack_public_path__ + "locales/ru/Translations.json?hash=d5bf03432b96cad321d5946b73832d52";